const DisplayComponent = ({ selectedItem }) => {
    if (!selectedItem) {
      return <p>Please select an item to see the details.</p>;
    }
  
    return (
      <div className="col-xl-6">
      <div className="row gy-4 px-24">

      <div className="shipping-item flex-align gap-16 rounded-16 bg-main-50 hover-bg-main-100 transition-2">
         
      <div className="">
        <span>
        <h7>Please scan the QR code to topUp, then click on request wallet</h7>
         </span>

  <img
    src={selectedItem.imageUrl}
    alt={selectedItem.name}
    style={{
      maxWidth: "150px",  // Adjust the size as per your requirement
      height: "auto",     // Maintain aspect ratio
      borderRadius: "8px", // Optional: if you want rounded corners
    }}
  />
  <h4>{selectedItem.name}</h4>
 </div>

  </div>  
     </div>
     
      </div>
 
    );
  };
  
  export default DisplayComponent;
  